import { observer } from 'src/utils/mobx-react';

import {
    OverlayDefault,
    Content,
    PopupHeader,
    PopupDescription,
    TermsBox,
    AcceptBtn,
    LinkWrapper,
} from 'src/domains/players/webview/components/Account/Notifications/BlockingNotifications.style';
import React from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Policy } from 'src/domains/players/webview/components/Account/resetPasswordProcedure/resetPasswordForm/Policy';
import { UniverseComponent } from 'src/domains/common/universes';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface BlockingTermsNotificationPropsType {
    onConfirm: () => Promise<void>;
}

export const BlockingTermsNotification = observer(
    'BlockingTermsNotification',
    ({ onConfirm }: BlockingTermsNotificationPropsType): JSX.Element | null => {
        const common = useCommon();
        const {
            accountHelperMail,
            componentVariants: { systemPagesVariant },
        } = ConfigComponents.get(common).config;

        return (
            <OverlayDefault data-test='overlay-prompt'>
                <Content>
                    <UniverseComponent>
                        {(universeModule): React.ReactElement => <universeModule.compliancePopupLogo />}
                    </UniverseComponent>
                    <PopupHeader>
                        <I18n
                            langKey='account.updated-terms-notification.title'
                            defaultText='Updated Terms and Conditions'
                        />
                    </PopupHeader>
                    <PopupDescription>
                        <I18n
                            langKey='account.updated-terms-notification.description-part-1'
                            defaultText='Our terms and conditions have been updated. To continue to use your account please read and accept the new terms and conditions.'
                        />
                    </PopupDescription>
                    <TermsBox systemPagesVariant={systemPagesVariant}>
                        <Policy
                            leftAlign
                            id='terms-and-conditions'
                        />
                    </TermsBox>

                    <PopupDescription>
                        <I18n
                            langKey='account.change-terms-notification.description-part-3'
                            defaultText=' If you do not wish to accept our new terms and conditions, do not click the Accept button and contact'
                        />{' '}
                        <LinkWrapper to={`mailto:${accountHelperMail}`}>
                            <I18n
                                langKey='account.deposit.info-page.email'
                                defaultText='{accountHelperMail}'
                                params={{ accountHelperMail }}
                            />
                        </LinkWrapper>
                    </PopupDescription>

                    <AcceptBtn
                        onClick={onConfirm}
                        size='medium'
                    >
                        <I18n
                            langKey='account.updated-terms-notification.confirm-button.label'
                            defaultText='Accept'
                        />
                    </AcceptBtn>
                </Content>
            </OverlayDefault>
        );
    }
);
